var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackgroundEyeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    transform: "matrix(-1 0 0 1 24 0)",
    fill: "#E9E9EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9375 9.86251C17.205 7.14001 14.67 5.57251 12 5.57251C10.665 5.57251 9.3675 5.96251 8.1825 6.69001C6.9975 7.42501 5.9325 8.49751 5.0625 9.86251C4.3125 11.04 4.3125 12.9525 5.0625 14.13C6.795 16.86 9.33 18.42 12 18.42C13.335 18.42 14.6325 18.03 15.8175 17.3025C17.0025 16.5675 18.0675 15.495 18.9375 14.13C19.6875 12.96 19.6875 11.04 18.9375 9.86251ZM12 15.03C10.32 15.03 8.97 13.6725 8.97 12C8.97 10.3275 10.32 8.97001 12 8.97001C13.68 8.97001 15.03 10.3275 15.03 12C15.03 13.6725 13.68 15.03 12 15.03Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.85498C10.8225 9.85498 9.86255 10.815 9.86255 12C9.86255 13.1775 10.8225 14.1375 12 14.1375C13.1775 14.1375 14.145 13.1775 14.145 12C14.145 10.8225 13.1775 9.85498 12 9.85498Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundEyeIcon);
export default __webpack_public_path__ + "static/media/background-eye-icon.20df65ab206c60a792f99cf1f6f44178.svg";
export { ForwardRef as ReactComponent };